(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kloraliv-product-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kloraliv-size-chart')) {
    customElements.define('kloraliv-size-chart', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          if (this.resizeObserver && this.body) this.resizeObserver.observe(this.body);
          return;
        }
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.button = this.querySelector('[data-chart-open]');
        this.body = this.querySelector('[data-chart-body]');
        if (!this.dialog || !this.button || !this.body) return;
        const lines = this.querySelector('[data-chart-lines]');
        if (lines) {
          this.buildTextTable(lines.content.textContent);
          lines.remove();
        }
        if (!this.body.textContent.trim() && !this.body.querySelector('img, table, a')) this.readDescription();
        const hasContent = this.body.textContent.trim() || this.body.querySelector('img, table, a');
        const note = document.querySelector('[data-chart-editor-note="' + this.dialog.id + '"]');
        if (!hasContent) return;
        if (note) note.hidden = true;
        this.hidden = false;
        this.button.addEventListener('click', () => {
          if (!this.dialog.open) this.dialog.showModal();
          this.button.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('kl-size-chart-open');
          requestAnimationFrame(() => this.updateScrollHint());
        });
        this.querySelector('[data-chart-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.button.setAttribute('aria-expanded', 'false');
          this.releaseScroll();
          if (this.button.isConnected) this.button.focus({ preventScroll: true });
        });
        this.resizeObserver = new ResizeObserver(() => { if (this.dialog.open) this.updateScrollHint(); });
        this.resizeObserver.observe(this.body);
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.releaseScroll();
      }

      releaseScroll() {
        if (!document.querySelector('dialog.kl-size-chart__dialog[open]')) document.documentElement.classList.remove('kl-size-chart-open');
      }

      updateScrollHint() {
        this.querySelector('[data-chart-scroll-hint]').hidden = this.body.scrollWidth <= this.body.clientWidth + 2;
      }

      normalize(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
      }

      buildTextTable(text) {
        const lines = text.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
        const rows = lines.filter(line => line.includes('|')).map(line => line.replace(/^\|\s*|\s*\|$/g, '').split('|').map(cell => cell.trim())).filter(row => !row.every(cell => /^:?-{2,}:?$/.test(cell)));
        if (rows.length < 2) {
          const paragraph = document.createElement('p');
          paragraph.textContent = text;
          paragraph.style.whiteSpace = 'pre-line';
          this.body.append(paragraph);
          return;
        }
        const table = document.createElement('table');
        const head = table.createTHead().insertRow();
        rows[0].forEach(value => { const cell = document.createElement('th'); cell.scope = 'col'; cell.textContent = value; head.append(cell); });
        const body = table.createTBody();
        rows.slice(1).forEach(values => { const row = body.insertRow(); values.forEach(value => { row.insertCell().textContent = value; }); });
        this.body.append(table);
        lines.filter(line => !line.includes('|')).forEach(line => { const p = document.createElement('p'); p.textContent = line; this.body.append(p); });
      }

      appendTable(source) {
        const table = source.cloneNode(true);
        table.querySelectorAll('script, style, iframe, object, embed, form, input, button, img, a').forEach(node => node.remove());
        [table, ...table.querySelectorAll('*')].forEach(node => {
          [...node.attributes].forEach(attribute => {
            if (!['colspan', 'rowspan', 'scope'].includes(attribute.name)) node.removeAttribute(attribute.name);
          });
        });
        const firstRow = table.rows[0];
        if (firstRow) [...firstRow.cells].forEach(cell => {
          if (cell.tagName === 'TH') { cell.scope = 'col'; return; }
          const heading = document.createElement('th');
          heading.scope = 'col';
          heading.textContent = cell.textContent;
          heading.colSpan = cell.colSpan;
          cell.replaceWith(heading);
        });
        this.body.append(table);
      }

      appendImage(source) {
        const raw = source.getAttribute('src') || source.getAttribute('data-src');
        if (!raw) return;
        let url;
        try { url = new URL(raw, location.href); } catch { return; }
        if (!['https:', 'http:'].includes(url.protocol)) return;
        const image = document.createElement('img');
        image.src = url.href;
        image.alt = this.dataset.imageLabel;
        image.loading = 'lazy';
        image.decoding = 'async';
        const link = document.createElement('a');
        link.href = url.href;
        link.target = '_blank';
        link.rel = 'noopener';
        link.className = 'kl-size-chart__enlarge';
        link.textContent = this.dataset.openImageLabel;
        this.body.append(image, link);
      }

      readDescription() {
        const template = this.querySelector('[data-chart-description]');
        if (!template) return;
        const source = template.content;
        const tables = [...source.querySelectorAll('table')].filter(table => {
          const firstRows = [...table.rows].slice(0, 2).map(row => row.textContent).join(' ');
          return table.rows.length > 1 && /\b(tallas?|sizes?|taglia|taglie|taille|grossen?|großen?|eu|uk|us)\b/.test(this.normalize(firstRows));
        });
        if (tables.length) { tables.forEach(table => this.appendTable(table)); return; }
        const images = new Set();
        source.querySelectorAll('img').forEach(image => {
          const label = this.normalize((image.getAttribute('alt') || '') + ' ' + (image.getAttribute('src') || ''));
          if (/(?:size[\s_-]*(?:chart|guide)|(?:tabla|guia)[\s_-]*(?:de[\s_-]*)?tallas|tabella[\s_-]*taglie)/.test(label)) images.add(image);
        });
        const headings = [...source.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div')].filter(node => {
          const text = this.normalize(node.textContent);
          return text.length < 100 && !node.querySelector('img, table') && /^(?:guia de tallas|tabla de tallas|tallas|tallaje|size chart|size guide|tabella (?:delle )?taglie|guida alle taglie)(?:\b|:)/.test(text);
        });
        headings.forEach(heading => {
          let anchor = heading;
          while (!anchor.nextElementSibling && anchor.parentElement && anchor.parentElement !== source) anchor = anchor.parentElement;
          let next = anchor.nextElementSibling;
          for (let step = 0; next && step < 6; step += 1, next = next.nextElementSibling) {
            const text = this.normalize(next.textContent);
            if (text && !/^(?:cm|centimetros|medidas en|pulgadas|inches)\b/.test(text)) break;
            if (next.matches('img')) images.add(next);
            next.querySelectorAll('img').forEach(image => images.add(image));
          }
        });
        const urls = new Set();
        images.forEach(image => {
          const url = image.getAttribute('src') || image.getAttribute('data-src');
          if (url && !urls.has(url)) { urls.add(url); this.appendImage(image); }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
